import withResponsive from '../hoc/withResponsive'
import Swiper from 'swiper/dist/js/swiper.min.js'

/**
 * Mock feature implementing most of the stuff on the stack.
 * Due to the 'withResponsive' HOC, foo will only mount on the requested breakpoints.
 *
 * Props:
 * shouldBar(boolean, optional): flag for toggling Bar
 * screens(object, optional): Used by withResponsive. object that can contains a 'min' and a 'max'
 * attribute. The breakpoints are specified in the withResponsive HOC.
 */
export default withResponsive({
  name: 'home-swiper-videos',

  ui: {
    'buttons[]': '[js-home-swiper-nav]',
  },

  events: [
    {
      target: 'buttons',
      on: 'mouseover',
      handle (e) {
        // console.log('slideTo', parseInt(e.currentTarget.getAttribute('js-home-swiper-nav')))
        this.swiper.slideToLoop(
          parseInt(e.currentTarget.getAttribute('js-home-swiper-nav'))
        )
      },
    },
  ],

  delay: 4000,

  componentDidMount () {
    const that = this

    this.videos = this.el.querySelectorAll('video')

    this.title = this.el.querySelector('.title-main')
    this.title = this.el.querySelectorAll('.title-main')

    setTimeout(() => {
      this.timer = 0
      this.swiper = new Swiper(this.el.querySelector('.swiper-container'), {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        // Optional parameters
        speed: 600,
        // initialSlide: self.el.querySelectorAll('.swiper-slide').length - 3, // 3 car slide-duplicate-...
        // reverseDirection: true,
        loop: true,
        loopedSlides: 0,
        // Navigation arrows
        /* navigation: {
          nextEl: '.swiper-home-actu-button-next',
          prevEl: '.swiper-home-actu-button-prev',
        }, */
        /* pagination: {
          el: '.swiper-home-actu-pagination',
          type: 'bullets',
          bulletElement: 'li',
        }, */
        slidesPerView: 1,
        spaceBetween: 0,
        // slidesOffsetBefore: 0,

        autoplay: {
          delay: this.delay,
          disableOnInteraction: false,
        },

        on: {
          /* slideChangeTransitionEnd: function () {
            that.animate(true)
          }, */

          slideChangeTransitionStart: () => {
            that.animate(false)
          },
        },
      })

      /* clearInterval(this.timer)
      this.timer = setInterval(()=>{
        this.el.querySelector('.slice__home-videos-slider__nav li')[this.nextActiveIndex].click()
      }, this.delay) */
    }, 2000)
  },

  animate () {
    if (!this.swiper) return

    let index = this.swiper.realIndex
    /* let prevIndex = this.swiper.previousIndex

    console.log( prevIndex === index )
    prevIndex = prevIndex === index ? prevIndex - 1 : prevIndex
    if(prevIndex >= this.ui.buttons.length ) prevIndex = this.ui.buttons.length - 1

    console.log( index, "/", prevIndex) */
    // if(this.videos[prevIndex]) this.videos[prevIndex ].pause()

    /* for (let v of this.videos) {
       v.pause()
     } */
    // comment for IE11
    this.videos.forEach(function (v) {
      v.pause()
    })

    const currentVideo = this.el.querySelector('.swiper-slide-active video')
    if (currentVideo) {
      currentVideo.currentTime = 0
      currentVideo.play()
    }

    // this.ui.buttons[ prevIndex ].classList.remove('is-active')
    /* for (let bt of this.ui.buttons) {
      bt.classList.remove('is-active')
    } */
    this.ui.buttons.forEach(function (bt) {
      bt.classList.remove('is-active')
    })
    this.ui.buttons[index].classList.add('is-active')

    if (index === 0) {
      this.title[0].classList.remove('title-main--white')
      this.title[0].classList.add('title-main--blue')

      for (let bt of this.ui.buttons) {
        bt.classList.remove('white')
        bt.classList.add('blue-light')
      }
    } else {
      this.title[0].classList.remove('title-main--blue')
      this.title[0].classList.add('title-main--white')

      /* for (let bt of this.ui.buttons) {
        bt.classList.remove('blue-light')
        bt.classList.add('white')
      } */
      this.ui.buttons.forEach(function (bt) {
        bt.classList.remove('blue-light')
        bt.classList.add('white')
      })
    }
  },
})
